// extracted by mini-css-extract-plugin
export default {"download-app__card":"UserPhotos_download-app__card__Tae02"};